const STATE_COLOR = {
  arrived: "#E6BFA6",
  playing: "#E6BFA6",
  resting: "#9BA995",
  eating: "#E6BFA6",
  learning: "#9BA995",
  safe: "#9BA995",
};

export default function AmbientDot({ state = "safe", size = 12 }) {
  const color = STATE_COLOR[state] || "#9BA995";
  return (
    <span
      data-testid={`ambient-dot-${state}`}
      className="ambient-dot relative inline-block rounded-full"
      style={{
        background: color,
        width: size,
        height: size,
      }}
    />
  );
}
